import React from 'react';

export default function TechnoCapeSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="15.02,9.42 8.38,9.42 8.38,4.44 15.02,4.44" fill="#B55C6A" />
      <polygon points="8.38,9.42 15.02,9.42 11.7,7.76 5.06,7.76" fill="#75353F" opacity="0.95" />
      <polygon points="8.38,9.42 5.06,7.76 5.06,2.77 8.38,4.44" fill="#75353F" opacity="0.95" />
      <polygon points="34.94,9.42 28.3,9.42 28.3,4.44 34.94,4.44" fill="#B55C6A" />
      <polygon points="28.3,9.42 34.94,9.42 31.62,7.76 24.98,7.76" fill="#75353F" opacity="0.95" />
      <polygon points="28.3,9.42 24.98,7.76 24.98,2.77 28.3,4.44" fill="#75353F" opacity="0.95" />
      <polygon points="12.64,38.0 9.65,36.51 9.65,3.3 12.64,4.79" fill="#75353F" opacity="0.95" />
      <polygon points="30.35,38.0 27.36,36.51 27.36,3.3 30.35,4.79" fill="#75353F" opacity="0.95" />
      <polygon points="32.06,9.97 13.91,9.97 13.91,3.33 32.06,3.33" fill="#B55C6A" />
      <polygon points="13.91,9.97 32.06,9.97 29.41,8.64 11.26,8.64" fill="#75353F" opacity="0.95" />
      <polygon points="13.91,9.97 11.26,8.64 11.26,2.0 13.91,3.33" fill="#75353F" opacity="0.95" />
      <polygon points="30.35,38.0 12.64,38.0 12.64,4.79 30.35,4.79" fill="#B55C6A" />
    </svg>
  );
}
